//
//
//
//
//

export default {
  name: 'empty-page',
  created(){
    const {path} = this.$route.query;

    this.$router.replace(path);
  },
}



// WEBPACK FOOTER //
// ./src/views/empty-page/empty-page.vue